/**
 * Alinea el título y el botón de todos los slides a la misma altura (solo desktop).
 * - Títulos: padding-top en text-inner para que queden al mismo nivel.
 * - Botones: margin-top en el wrapper del botón para que la línea de inicio del botón
 *   sea la misma aunque el texto descriptivo o el texto del botón ocupen distinto número de líneas.
 * - Mobile: no se alinea; se limpian padding/margin para que el layout apilado no se rompa.
 */
(function () {
  var SECTION_SELECTOR = '.image-with-text-split-edit';
  var INNER_SELECTOR = '.image-with-text-split-edit__text-inner';
  var HEADING_SELECTOR = '.image-with-text-split-edit__heading, .iwts-heading';
  var BUTTON_SELECTOR = '.section-blocks__button';

  var MOBILE_BREAKPOINT = 960;
  var DEBUG_LOGS = true; /* true para ver [iwts] en consola (alineamiento títulos/botones desktop) */

  function alignTitlesInSection(section) {
    var inners = section.querySelectorAll(INNER_SELECTOR);
    if (inners.length === 0) return;

    var items = [];
    var i;
    for (i = 0; i < inners.length; i++) {
      var inner = inners[i];
      var heading = inner.querySelector(HEADING_SELECTOR);
      inner.style.paddingTop = '';
      if (heading) {
        var headingTop = heading.getBoundingClientRect().top;
        items.push({ inner: inner, heading: heading, viewportY: headingTop });
      } else {
        items.push({ inner: inner, heading: null, viewportY: 0 });
      }
    }

    var withHeading = items.filter(function (o) { return o.heading; });
    if (withHeading.length < 2) return;

    var maxY = Math.max.apply(null, withHeading.map(function (o) { return o.viewportY; }));
    for (i = 0; i < items.length; i++) {
      if (!items[i].heading) continue;
      var pad = maxY - items[i].viewportY;
      items[i].inner.style.paddingTop = (pad > 0 ? pad : 0) + 'px';
    }
    if (DEBUG_LOGS && typeof console !== 'undefined' && console.log) {
      console.log('[iwts] alignTitles: inners=', inners.length, 'paddingTop (px)=', items.map(function (o) { return o.heading ? (parseFloat(o.inner.style.paddingTop) || 0) : '-'; }));
    }

    /* Pases adicionales: al aplicar padding el layout puede cambiar; iterar hasta alinear (< 1px) */
    var maxIter = 5;
    var finalTops;
    var diff = 999;
    while (maxIter-- > 0 && diff >= 1) {
      finalTops = items.filter(function (o) { return o.heading; }).map(function (o) {
        return o.heading.getBoundingClientRect().top;
      });
      if (finalTops.length < 2) break;
      var maxY2 = Math.max.apply(null, finalTops);
      diff = maxY2 - Math.min.apply(null, finalTops);
      if (diff < 1) break;
      for (i = 0; i < items.length; i++) {
        if (!items[i].heading) continue;
        var curY = items[i].heading.getBoundingClientRect().top;
        var extra = maxY2 - curY;
        if (extra > 0) {
          var currentPad = parseFloat(items[i].inner.style.paddingTop) || 0;
          items[i].inner.style.paddingTop = (currentPad + extra) + 'px';
        }
      }
    }
    finalTops = items.filter(function (o) { return o.heading; }).map(function (o) {
      return o.heading.getBoundingClientRect().top;
    });
    diff = finalTops.length >= 2 ? (Math.max.apply(null, finalTops) - Math.min.apply(null, finalTops)) : 0;

    if (DEBUG_LOGS && typeof console !== 'undefined' && console.log && finalTops.length >= 2) {
      var diffTitlesPx = Math.max.apply(null, finalTops) - Math.min.apply(null, finalTops);
      var titlesAligned = diffTitlesPx < 2;
      console.log('[iwts] Títulos ' + (titlesAligned ? 'alineados OK' : 'desalineados') + ' (diff ' + diffTitlesPx.toFixed(2) + 'px)');
    }
  }

  /**
   * Alinea el inicio del botón (wrapper .section-blocks__button) en todos los slides
   * a la misma altura, aplicando margin-top para compensar diferencias de texto/descripción.
   */
  function alignButtonsInSection(section) {
    var inners = section.querySelectorAll(INNER_SELECTOR);
    if (inners.length === 0) return;

    var items = [];
    var i;
    for (i = 0; i < inners.length; i++) {
      var inner = inners[i];
      var btn = inner.querySelector(BUTTON_SELECTOR);
      if (btn) btn.style.marginTop = '';
      if (btn) {
        var btnTop = btn.getBoundingClientRect().top;
        items.push({ inner: inner, button: btn, viewportY: btnTop });
      }
    }

    if (items.length < 2) return;

    var maxY = Math.max.apply(null, items.map(function (o) { return o.viewportY; }));

    for (i = 0; i < items.length; i++) {
      var pad = maxY - items[i].viewportY;
      items[i].button.style.marginTop = (pad > 0 ? pad : 0) + 'px';
    }
    if (DEBUG_LOGS && typeof console !== 'undefined' && console.log) {
      console.log('[iwts] alignButtons: buttons=', items.length, 'marginTop (px)=', items.map(function (o) { return parseFloat(o.button.style.marginTop) || 0; }));
    }

    /* Iteraciones: el margin-top puede cambiar el layout; seguir hasta quedar < 0.5px */
    var maxIter = 12;
    var diff = 999;
    while (maxIter-- > 0 && diff >= 0.5) {
      var tops = items.map(function (o) { return o.button.getBoundingClientRect().top; });
      var maxY2 = Math.max.apply(null, tops);
      diff = maxY2 - Math.min.apply(null, tops);
      if (diff < 0.5) break;
      for (i = 0; i < items.length; i++) {
        var curY = items[i].button.getBoundingClientRect().top;
        var extra = maxY2 - curY;
        if (extra > 0) {
          var current = parseFloat(items[i].button.style.marginTop) || 0;
          items[i].button.style.marginTop = (current + extra) + 'px';
        }
      }
    }
    /* Pase final por si el último reflow dejó una diferencia residual */
    var finalTopsOnce = items.map(function (o) { return o.button.getBoundingClientRect().top; });
    var maxYFinal = Math.max.apply(null, finalTopsOnce);
    for (i = 0; i < items.length; i++) {
      var curY = items[i].button.getBoundingClientRect().top;
      var extra = maxYFinal - curY;
      if (extra > 0.25) {
        var current = parseFloat(items[i].button.style.marginTop) || 0;
        items[i].button.style.marginTop = (current + extra) + 'px';
      }
    }

    if (DEBUG_LOGS && typeof console !== 'undefined' && console.log) {
      var finalTopsBtn = items.map(function (o) { return o.button.getBoundingClientRect().top; });
      var diffPx = finalTopsBtn.length >= 2 ? (Math.max.apply(null, finalTopsBtn) - Math.min.apply(null, finalTopsBtn)) : 0;
      var aligned = diffPx < 2;
      console.log('[iwts] Botones ' + (aligned ? 'alineados OK' : 'desalineados') + ' (diff ' + diffPx.toFixed(2) + 'px)');
    }
  }

  function run() {
    var isMobile = typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT;
    if (DEBUG_LOGS && typeof console !== 'undefined' && console.log) {
      console.log('[iwts] run: viewport=', typeof window !== 'undefined' ? window.innerWidth : '?', 'isMobile=', isMobile);
    }
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      if (isMobile) {
        /* En mobile no alineamos: los slides van apilados y el padding/margin rompe el layout */
        section.querySelectorAll(INNER_SELECTOR).forEach(function (inner) {
          inner.style.paddingTop = '';
        });
        section.querySelectorAll(BUTTON_SELECTOR).forEach(function (btn) {
          btn.style.marginTop = '';
        });
        if (DEBUG_LOGS && typeof console !== 'undefined' && console.log) {
          console.log('[iwts] mobile: limpiados paddingTop y marginTop');
        }
        return;
      }
      alignTitlesInSection(section);
      alignButtonsInSection(section);
    });
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(run, 100);
    });
  } else {
    setTimeout(run, 100);
  }

  window.addEventListener('resize', debounce(run, 150));

  // Theme editor puede inyectar la sección dinámicamente
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector(SECTION_SELECTOR)) setTimeout(run, 100);
    });
  }
})();
